import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles} from '@material-ui/core/styles'
import {
  Grid, Table, TableHeaderRow
} from '@devexpress/dx-react-grid-material-ui'

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word"
  }
}

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
)

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0
    }}
    {...restProps}
  />
)

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class UserTable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "actionColumn", title: "Benutzer Einstellungen" },
        { name: "descriptionColumn", title: "Beschreibung" }
      ],
      rows: [
        { actionColumn: 'Benutzer hinzufügen', descriptionColumn: 'Klicken Sie auf die grüne Schaltfläche +, um einen neuen Kameranutzer hinzuzufügen.' },
        { actionColumn: 'Name', descriptionColumn: 'Wählen Sie einen Namen für die Benutzeranmeldung.' },
        { actionColumn: 'Kennwort', descriptionColumn: 'Wählen Sie ein Passwort für die Benutzeranmeldung.' },
        { actionColumn: 'Benutzerebene', descriptionColumn: 'Wählen Sie aus, wie viele Rechte der Benutzer haben soll - Gast, Bediener oder Administrator' },
        { actionColumn: 'Administrator', descriptionColumn: 'Ein Administrator-Benutzer hat Zugriff auf alle Funktionen der Kamera. Die Standardeinstellung ist admin/instar. Die Anmeldung wird während der ersten Schritte des Einrichtungsassistenten auf einen persönlichen Benutzernamen und ein Kennwort festgelegt.' },
        { actionColumn: 'Operator', descriptionColumn: 'Dies ist eine normale Benutzeranmeldung. Der Benutzer hat Zugriff auf den Videostream und kann Ihre Kamera auch schwenken und neigen (nur PTZ-Kameras). Das Konfigurationsmenü ist nicht verfügbar. Standardmäßig deaktiviert.' },
        { actionColumn: 'Gast', descriptionColumn: 'Dies ist eine Gastanmeldung. Der Gast hat nur Zugriff auf den Videostream. Standardmäßig deaktiviert.' },
        { actionColumn: 'Login-Gültigkeitsdauer', descriptionColumn: 'Wenn Sie sich bei der Web-Benutzeroberfläche anmelden, speichert Ihr Browser ein Zugangs-Token. Sie müssen sich nur dann erst erneut anmelden, wenn Sie Ihren Browserverlauf löschen oder das Zugangstoken abläuft. Hier können Sie die Verfallszeit einstellen.' },
        { actionColumn: 'Sprache', descriptionColumn: 'Auswahl der Sprache für die Benutzeroberfläche.' },
      ]
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{display: 'inline-block', maxWidth: '915px'}}>
        <Grid rows={rows} columns={columns}>
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
        </Grid>
      </Paper>
    );
  }
}

UserTable.propTypes = {
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(UserTable)